import { Button } from "../../components/ui/button.jsx";
import { Calendar, Link2, Phone, Video } from "lucide-react";

const ACTIONS = [
  {
    key: "start",
    label: "Start call",
    description: "Jump into a room instantly with current participants.",
    icon: Video,
  },
  {
    key: "new-link",
    label: "New call link",
    description: "Generate a reusable invite that you can share anywhere.",
    icon: Link2,
  },
  {
    key: "dial",
    label: "Call a number",
    description: "Bridge external teammates or clients via PSTN.",
    icon: Phone,
  },
  {
    key: "schedule",
    label: "Schedule call",
    description: "Pick a time, set reminders, and add to calendar.",
    icon: Calendar,
  },
];

export default function CallActionGrid({ onStart, onNewLink, onDial, onSchedule }) {
  const handlers = {
    start: onStart,
    "new-link": onNewLink,
    dial: onDial,
    schedule: onSchedule,
  };

  return (
    <div className="mt-8 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {ACTIONS.map((action) => {
        const Icon = action.icon;
        return (
          <div key={action.key} className="glass-card flex h-full flex-col justify-between rounded-3xl p-5 text-sm">
            <div>
              <div className="flex items-center gap-2 text-sm font-semibold text-foreground">
                <span className="grid h-9 w-9 place-items-center rounded-full bg-primary/10 text-primary">
                  <Icon className="h-4 w-4" />
                </span>
                {action.label}
              </div>
              <p className="mt-2 text-xs text-muted-foreground">{action.description}</p>
            </div>
            <Button
              type="button"
              size="sm"
              onClick={handlers[action.key]}
              className="mt-5 w-full"
            >
              {action.key === "start" ? "Start now" : action.key === "new-link" ? "Create link" : action.key === "dial" ? "Open dialer" : "Pick time"}
            </Button>
          </div>
        );
      })}
    </div>
  );
}
